export default "__VITE_ASSET__Dlem9SsK__"